
import React from 'react';

const BookingButton = ({
  id, onClick, number, label,
}) => (
  <button
    id={id}
    type="button"
    className="btn btn-secondary"
    onClick={onClick}
    disabled={number === 0}
  >
    {label}
    <span className="m-l-5">
      (
      {number}
      )
    </span>
  </button>
);
export default BookingButton;
